<h2 mat-dialog-title>{{isEdit ? 'Komponente bearbeiten' : 'Neue Komponente'}}</h2>

<mat-dialog-content>
  <div class="form-grid">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Komponentenname</mat-label>
      <input matInput [(ngModel)]="component.name" required placeholder="z.B. Siemens S7-1516F">
      <mat-icon matPrefix>widgets</mat-icon>
    </mat-form-field>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Version</mat-label>
        <input matInput [(ngModel)]="component.version" placeholder="z.B. V2.9.4">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Komponententyp</mat-label>
        <mat-select [(ngModel)]="component.componentType">
          <mat-option value="">-</mat-option>
          <mat-option *ngFor="let ct of componentTypes" [value]="ct">{{ct}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Lieferant / Hersteller</mat-label>
        <input matInput [(ngModel)]="component.supplier" placeholder="z.B. Siemens AG">
        <mat-icon matPrefix>business</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Artikelnummer</mat-label>
        <input matInput [(ngModel)]="component.partNumber" placeholder="z.B. 6ES7516-3FN02-0AB0">
        <mat-icon matPrefix>tag</mat-icon>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Lizenz</mat-label>
      <input matInput [(ngModel)]="component.license" placeholder="z.B. Siemens Lizenz, MIT, Proprietär">
    </mat-form-field>

    <div class="section-label">Hash</div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="hash-field">
        <mat-label>Komponenten-Hash</mat-label>
        <input matInput [(ngModel)]="component.componentHash" placeholder="Hash-Wert der Komponente">
        <mat-icon matPrefix>fingerprint</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="algo-field">
        <mat-label>Algorithmus</mat-label>
        <mat-select [(ngModel)]="component.hashAlgorithm">
          <mat-option value="">-</mat-option>
          <mat-option *ngFor="let algo of hashAlgorithms" [value]="algo">{{algo}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>End-of-Life Datum</mat-label>
      <input matInput [matDatepicker]="eolPicker" [(ngModel)]="component.endOfLife">
      <mat-datepicker-toggle matSuffix [for]="eolPicker"></mat-datepicker-toggle>
      <mat-datepicker #eolPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Beschreibung</mat-label>
      <textarea matInput [(ngModel)]="component.description" rows="2" placeholder="Optionale Beschreibung..."></textarea>
    </mat-form-field>

    <mat-slide-toggle [(ngModel)]="component.isCritical" color="warn">
      Kritische Komponente
    </mat-slide-toggle>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!component.name?.trim() || saving">
    <mat-spinner *ngIf="saving" diameter="18"></mat-spinner>
    {{isEdit ? 'Speichern' : 'Hinzufügen'}}
  </button>
</mat-dialog-actions>
